<template>
    <div class="banned-notice" v-if="show">
        <div class="main">
            <div v-html="content" class="content"></div>
            <div class="btn" @click.stop="handleClose">
                我知道了
            </div>
        </div>
    </div>
</template>
<script>

import { getUserBannedInfo } from '@/_utils/request'

export default {
    data() {
        return {
            show: false,
            username: '',// 用户名
            banDate: '',// 禁言结束时间，为null为永远
            banStatus: true,// 是否禁言
            banDay: 0,// 禁言天数，等于0为永远
        }
    },
    computed: {
        formatBanDate() {
            return this.banDate ? this.formatDate(this.banDate) : ''
        },
        content() {
            if(this.banStatus) {
                const templates =  {
                    // 永久
                    forever: `
                        因您发言内容违反社区<a href='//m.sohu.com/a/739523038_99975564'>《用户公约》</a>，
                        发评论功能已被停止使用。
                        如有疑问，点此<a href='//m.sohu.com/feedback?page=function'>反馈></a>`,
                    // 短暂
                    moment: `
                        因您发言内容违反社区<a href='//m.sohu.com/a/739523038_99975564'>《用户公约》</a>，
                        发评论功能停止使用${this.banDay}天，
                        预计${this.formatBanDate}恢复。
                        请您善意表达，勿发布违规内容。
                        如有疑问，点此<a href='//m.sohu.com/feedback?page=function'>反馈></a>`
                }
                return this.banDay <= 0 ? templates['forever'] : templates['moment']
            }
        }
    }, 
    mounted() {
        window?.EVENT_BUS?.$on('showBannedNotice',this.showBannedNotice)
        this.getUserBannedInfo()
    },
    methods: {
        formatDate(timestamp) {
            const date = new Date(Number(timestamp));
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并且确保两位数
            const day = String(date.getDate()).padStart(2, '0'); // 确保两位数
            const formattedDate = `${year}年${month}月${day}号`;
            return formattedDate
        },
        getUserBannedInfo() {
            getUserBannedInfo().then((res)=>{
                if(res.code==200 && res.data) {
                    this.banDate = res.data?.banDate
                    this.banStatus = res.data?.banStatus
                    this.banDay = res.data?.banDay
                }
            })
        },
        showBannedNotice() {
            this.show = true
            this.getUserBannedInfo()
        },
        handleClose() {
            this.show = false
        }
    }
}
</script>
<style lang="less" scoped>
    .banned-notice {
        font-family: PingFangSC, PingFang SC;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        .main {
            width: 560px; /*px*/
            background: #FFFFFF;
            border-radius: 8px;/*px*/
            box-sizing: border-box;
            padding: 64px 64px 48px 64px;/*px*/
            z-index: 1001;
            .content {
                font-weight: 400;
                font-size: 28px;/*px*/
                color: #999999;
                line-height: 40px;/*px*/
                /deep/a {
                    font-size: 28px;/*px*/
                    color: #E67A00 !important;
                    text-decoration: underline !important;
                }
            }
            .btn {
                margin-top: 64px;/*px*/
                width: 100%;
                height: 72px;/*px*/
                background: #F2F2F2;
                border-radius: 8px;/*px*/
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 500;
                font-size: 28px;/*px*/
                color: #111111;
            }
        }
    }
</style>